const CryptoJS = require('crypto-js');

export const encryptData = (key, data) => {
  return CryptoJS.AES.encrypt(key, data).toString();
};

export const decryptData = (key, data) => {
  const decrypted = CryptoJS.AES.decrypt(key, data);
  return decrypted.toString(CryptoJS.enc.Utf8);
};
